export enum Education {
	publicSchool,
	vocationalSchool,
	upperSecondarySchool,
	appliedSciencesUniversity,
	university,
	other
};

export type EducationKeys = keyof typeof Education;